module.exports = __webpack_public_path__ + "static/media/contact08.74750647.png";